/**
 * WebSocket message type string literals — wire values.
 * Source of truth: asyncapi.yaml
 */

/** Client → Server message types */
export const ClientMessageType = {
  BetPlace: 'bet:place',
  BetCancel: 'bet:cancel',
  BetCashout: 'bet:cashout',
  ProfileUpdate: 'profile:update',
  PlayerStatsGet: 'player:stats:get',
  PlayerBetHistoryGet: 'player:betHistory:get',
  LeaderboardGet: 'leaderboard:get',
  StreamerJoin: 'streamer:join',
  StreamerLeave: 'streamer:leave',
  StreamerListGet: 'streamer:list:get',
} as const;

export type ClientMessageType = (typeof ClientMessageType)[keyof typeof ClientMessageType];

/** Server → Client message types */
export const ServerMessageType = {
  SessionInit: 'session:init',
  PlayersOnline: 'players:online',
  RoundState: 'round:state',
  Tick: 'tick',
  RoundCrashed: 'round:crashed',
  AutoCashout: 'auto:cashout',
  BalanceUpdate: 'balance:update',
  PlayerStats: 'player:stats',
  PlayerBetHistoryData: 'player:betHistory:data',
  LeaderboardData: 'leaderboard:data',
  StreamerRoomUpdate: 'streamer:roomUpdate',
  StreamerList: 'streamer:list',
  BetPlaceAck: 'bet:place',
  BetCancelAck: 'bet:cancel',
  BetCashoutAck: 'bet:cashout',
  Error: 'error',
} as const;

export type ServerMessageType = (typeof ServerMessageType)[keyof typeof ServerMessageType];

/** Union of all wire values */
export type WsMessageType = ClientMessageType | ServerMessageType;
